import httpV2 from '@/utils/httpV2';

const state = {

};
const getters = {};

const mutations = {};

const actions = {
    //分页获取咨询列表
    getConsultationPage({ state, commit }, params) {
        let promise = httpV2.get2("/b2c/v1.0/user/consultation/page/list", params, this);
        return promise;
    },
    getReply({ state, commit }, params) {
        let promise = httpV2.get2("/b2c/v1.0/user/consultation", params, this);
        return promise;
    },
    reply({ state, commit }, params) {
        let promise = httpV2.put("/b2c/v1.0/user/consultation", params, this);
        return promise;
    },
};

export default {
    getters,
    state,
    mutations,
    actions
};